import styled from "styled-components"

import {H2} from "@irati/ui/src//Typography/Heading"

export const CenterH1 = styled(H2)`
  text-align: center;
`

export const Wrapper = styled.div`
  padding: 0;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999999999;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

const BORDER_CLIP_RADIUS_PX = 10

export const Notification = styled.div`
  border-radius: ${BORDER_CLIP_RADIUS_PX}px;
  align-self: center;
  background-color: ${({theme}) => theme.colors.greys.white};
  width: 65vw;
  max-height: 1200px;
  max-width: 1200px;
`
export const WelcomeImage = styled.div`
  border-top-left-radius: ${BORDER_CLIP_RADIUS_PX - 1}px;
  border-top-right-radius: ${BORDER_CLIP_RADIUS_PX - 1}px;
  background-image: url("https://res.cloudinary.com/perkbox/image/upload/v1573118900/4d63dbae-83dd-42b9-86c4-29be56e47057.png");
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 45vh;
`

export const ContentWrapper = styled.div`
  padding: 30px;
  max-width: 750px;
  margin: 0 auto;
`

export const CloseWrapper = styled.div`
  position: relative;
`
